import * as UI from './third-party.styled'
import React from 'react'

export const ThirdPartyWrapper = ({children}: React.PropsWithChildren) => (
  <UI.ThirdPartyWrapper>{children}</UI.ThirdPartyWrapper>
)
